import { is } from 'cypress/types/bluebird'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { LogsBarInner } from './helper/LogsBarInner'
import { LogsBarOuter } from './helper/LogsBarOuter'

interface Props {
  isBackLog?: boolean
  polesNumber: number
  height: number
}

export const LogsFront = ({
  isBackLog = false,
  polesNumber = 0,
  height,
}: Props): JSX.Element => {
  const { eaves, eavesWidth, frontHeight, isQubus } = useMeasures()
  const logHeight = isQubus ? frontHeight : height
  return (
    <group position={[0, 0, eaves && !isBackLog ? -eavesWidth : 0]}>
      <LogsBarOuter isBackLog={isBackLog} logBarHeight={logHeight} />
      <LogsBarInner
        isBackLog={isBackLog}
        logBarHeight={logHeight}
        polesNumber={polesNumber}
      />
    </group>
  )
}
